/**
 * Маппер живого ClientListItem гейтвея → доменный тип прототипа.
 * Деньги приходят в тыйынах — колонки показывают сомы; nullable-строки
 * бэка заменяем прочерком, чтобы таблица не разъезжалась.
 */

import type {ClientListItem, SubscriptionStatus} from '../types';

const asStr = (v: unknown, fallback = ''): string => (typeof v === 'string' ? v : fallback);
const asNum = (v: unknown, fallback = 0): number => (typeof v === 'number' ? v : fallback);

const STATUSES: SubscriptionStatus[] = [
  'trial',
  'trial_expired',
  'awaiting_card',
  'active',
  'past_due',
  'blocked',
  'cancelled',
];

const asStatus = (v: unknown): SubscriptionStatus =>
  STATUSES.includes(v as SubscriptionStatus) ? (v as SubscriptionStatus) : 'trial';

export const toClientListItem = (raw: unknown): ClientListItem => {
  const r = (typeof raw === 'object' && raw !== null ? raw : {}) as Record<string, unknown>;
  return {
    id: asStr(r.id),
    type: r.type === 'solo' ? 'solo' : 'clinic',
    name: asStr(r.name, '—'),
    adminFullName: asStr(r.adminFullName, '—'),
    adminPhone: asStr(r.adminPhone, ''),
    cityName: asStr(r.cityName, '—'),
    tariffName: asStr(r.tariffName, '—'),
    tariffLabel: asStr(r.tariffLabel, '—'),
    seatsUsed: asNum(r.seatsUsed),
    seatsLimit: typeof r.seatsLimit === 'number' ? r.seatsLimit : null,
    patientsCount: asNum(r.patientsCount),
    revenue: Math.round(asNum(r.revenueTiyin) / 100),
    lifetimeRevenue:
      typeof r.lifetimeRevenueTiyin === 'number' ? Math.round(r.lifetimeRevenueTiyin / 100) : null,
    subscriptionStatus: asStatus(r.subscriptionStatus),
    trialDay: typeof r.trialDay === 'number' ? r.trialDay : null,
    lastActiveAt: typeof r.lastActiveAt === 'string' ? r.lastActiveAt : null,
    createdAt: asStr(r.createdAt),
    currentPeriodEnd: typeof r.currentPeriodEnd === 'string' ? r.currentPeriodEnd : null,
  };
};
